import * as C from './Container.styles';
import React from 'react';

const Container = ({ size, children }) => {
  return <C.Wrapper size={size}>{children}</C.Wrapper>;
};
export default Container;
